<template>
  <div class="yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]">
    <navBar :title="$t('todo.title')" />
    <div class="text-md px-4 mt-3" @click="handleClick">{{$t('todo.completed1')}}</div>
    <div class="grid grid-cols-3 gap-x-3 gap-y-3 px-4 mt-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6">
      <!-- 会员注册 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo">
        <img :src="registerSrc" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.register") }}</div>
        <div class="text-sm">+100 {{ $t("mine.points") }}</div>
      </div>
      <!-- 完善资料 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo.zlStatus === 1">
        <img :src="zlSrc" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.completePersonalInfo") }}</div>
        <div class="text-sm">+{{ todoInfo.zlPoint }} {{ $t("mine.points") }}</div>
      </div>

      <!-- 分享社交媒体 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo.shareStatus === 1">
        <img :src="shareSrc" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.share") }}</div>
        <div class="text-sm">+{{ todoInfo.sharePoint }} {{ $t("mine.points") }}</div>
      </div>
      <!-- 五星好评 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo.reviewTodoStatus === 0">
        <img :src="commentSrc" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.commentOnTheOrder") }}</div>
        <div class="text-sm">+{{ todoInfo.commentPoint }} {{ $t("mine.points") }}</div>
      </div>
      <!-- 邀请好友 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo.inviteStatus === 1">
        <img :src="inviteSrc" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.recommend") }}</div>
        <div class="text-sm">+{{ todoInfo.invitePoint }} {{ $t("mine.points") }}</div>
      </div>
      <!-- 签到 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo.signStatus === 1">
        <img :src="signSrc" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.dailyAttendance") }}</div>
        <div class="text-sm">+xxx {{ $t("mine.points") }}</div>
      </div>
      <!-- 完成3单 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo.order3Status === 1">
        <img :src="order3Src" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.complete3Orders") }}</div>
        <div class="text-sm">+{{ todoInfo.order3Point }} {{ $t("mine.points") }}</div>
      </div>
      <!-- 完成6单 -->
      <div
        class="flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]"
        v-if="todoInfo.order6Status === 1">
        <img :src="order6Src" class="w-12 h-12" />
        <div class="text-sm text-center mt-1">{{ $t("todo.complete6Orders") }}</div>
        <div class="text-sm">+{{ todoInfo.order6Point }} {{ $t("mine.points") }}</div>
      </div>
    </div>

    <div class="text-md px-4 mt-8">{{ $t("todo.ongoing") }}</div>
    <div class="grid grid-cols-3 gap-x-3 gap-y-5 px-4 pb-4 mt-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6">
      <!-- 完善资料 -->
      <div v-if="todoInfo.zlStatus === 0" class="flex flex-col items-center justify-center">
        <div
          class="flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5">
          <img :src="zlSrc" class="w-12 h-12" />
          <div class="text-sm text-center mt-1 text-gray-500">{{ $t("todo.completePersonalInfo") }}</div>
          <div class="text-sm text-gray-500">{{ todoInfo.zlPoint }} {{ $t("mine.points") }}</div>
        </div>
        <div class="text-sm  invisible">占位</div>
        <van-button type="primary" class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500" @click="goTo('/user-info')">
          {{ $t("todo.toComplete") }}
        </van-button>
      </div>

      <!-- 社交媒体分享 -->
      <div v-if="todoInfo.shareStatus === 0" class="flex flex-col items-center justify-center">
        <div
          class="flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5">
          <img :src="shareSrc" class="w-12 h-12" />
          <div class="text-sm text-center mt-1 text-gray-500">{{ $t("todo.share") }}</div>
          <div class="text-sm text-gray-500">{{ todoInfo.sharePoint }} {{ $t("mine.points") }}</div>
        </div>
        <div class="text-sm  invisible">占位</div>
        <van-button type="primary" class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500" @click="handleShare">
          {{ $t("todo.contactService") }}
        </van-button>
      </div>
      <!-- 五星好评 -->
      <div v-if="todoInfo.reviewTodoStatus == 1 || todoInfo.reviewTodoStatus == -1" class="flex flex-col items-center justify-center">
        <div
          class="flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5">
          <img :src="commentSrc" class="w-12 h-12" />
          <div class="text-sm text-center mt-1 text-gray-500">{{ $t("todo.commentOnTheOrder") }}</div>
          <div class="text-sm text-gray-500">{{ todoInfo.commentPoint }} {{ $t("mine.points") }}</div>
        </div>
        <!-- <div class="text-sm mt-3">{{ $t("todo.progress") }}: {{ $t("todo.completed") }} {{ todoInfo.commentCount }} / 4</div> -->
        <div class="text-sm  invisible">占位</div>
        <van-button v-if="todoInfo.reviewTodoStatus == 1" type="primary" class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500" @click="goTo('/my-reviews')">
          {{ $t("todo.toComplete") }}
        </van-button>
        <van-button v-if="todoInfo.reviewTodoStatus == -1" type="primary" class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2">
          {{ $t("todo.toComplete") }}
        </van-button>
      </div>

      <!-- 邀请好友 -->
      <div v-if="todoInfo.inviteStatus === 0" class="flex flex-col items-center justify-center">
        <div
          class="flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5">
          <img :src="inviteSrc" class="w-12 h-12" />
          <div class="text-sm text-center mt-1 text-gray-500">{{ $t("todo.recommend") }}</div>
          <div class="text-sm text-gray-500">{{ todoInfo.invitePoint }} {{ $t("mine.points") }}</div>
        </div>
        <div class="text-sm  invisible">占位</div>
        <van-button
          type="primary"
          id="invite"
          class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500"
          :data-clipboard-text="inviteLink">
          {{ $t("todo.copyLink") }}
        </van-button>
      </div>

      <!-- 签到 -->
      <div v-if="todoInfo.signStatus === 0" class="flex flex-col items-center justify-center">
        <div
          class="flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5">
          <img :src="signSrc" class="w-12 h-12" />
          <div class="text-sm text-center mt-1 text-gray-500">{{ $t("todo.dailyAttendance") }}</div>
          <div class="text-sm text-gray-500">xxx {{ $t("mine.points") }}</div>
        </div>
        <div class="text-sm  invisible">占位</div>
        <van-button
          type="primary"
          class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500"
          @click="goTo('/yoyo-coin-introduce')">
          {{ $t("todo.goCollect") }}
        </van-button>
      </div>

      <!-- 完成3单 -->
      <div v-if="todoInfo.order3Status === 0" class="flex flex-col items-center justify-center">
        <div
          class="flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5">
          <img :src="order3Src" class="w-12 h-12" />
          <div class="text-sm text-center mt-1 text-gray-500">{{ $t("todo.complete3Orders") }}</div>
          <div class="text-sm text-gray-500">{{ todoInfo.order3Point }} {{ $t("mine.points") }}</div>
        </div>
        <div class="text-sm  invisible">占位</div>
        <van-button type="primary" class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500" @click="goTo('/home')">
          {{ $t("todo.toComplete") }}
        </van-button>
      </div>

      <!-- 完成6单 -->
      <div v-if="todoInfo.order6Status === 0" class="flex flex-col items-center justify-center">
        <div
          class="flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5">
          <img :src="order6Src" class="w-12 h-12" />
          <div class="text-sm text-center mt-1 text-gray-500">{{ $t("todo.complete6Orders") }}</div>
          <div class="text-sm text-gray-500">{{ todoInfo.order6Point }} {{ $t("mine.points") }}</div>
        </div>
        <div class="text-sm  invisible">占位</div>
        <van-button type="primary" class="mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500" @click="goTo('/home')">
          {{ $t("todo.toComplete") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getTodoList } from "@/apis/mine"
import ClipboardJS from "clipboard"

import { Toast } from "vant"

var clipboard = new ClipboardJS("#invite")

export default {
  name: "MyToDo",
  data() {
    return {
      todoInfo: "",
      zlSrc: require("@/assets/images/todo/3.png"), // 完善资料
      shareSrc: require("@/assets/images/todo/7.png"), // 分享社交媒体
      commentSrc: require("@/assets/images/todo/5.png"), // 五星好评
      inviteSrc: require("@/assets/images/todo/6.png"), // 邀请好友
      signSrc: require("@/assets/images/todo/1.png"), // 签到
      order3Src: require("@/assets/images/todo/4.png"), // 完成3单
      order6Src: require("@/assets/images/todo/4.png"), // 完成6单
      registerSrc: require("@/assets/images/todo/2.png"), // 会员注册
      inviteLink: "",
    }
  },
  methods: {
    getTodoList() {
      getTodoList()
        .then((res) => {
          this.todoInfo = res.data
          // this.inviteLink = 'http://localhost:8080' + "/home?inviteCode=" + this.todoInfo.inviteCode
          this.inviteLink = process.env.VUE_APP_IMAGE_URL + "/home?inviteCode=" + this.todoInfo.inviteCode
        })
        .catch((err) => {
          // this.inviteLink = process.env.VUE_APP_IMAGE_URL + "/home?inviteCode=" + this.todoInfo.inviteCode
          console.log(err)
        })
    },
    handleShare() {
      this.openInNewTab("https://wa.me/60143869383")
    },
    openInNewTab(url) {
      // 创建一个虚拟的 a 标签
      const link = document.createElement("a")
      link.href = url
      link.target = "_blank"
      link.rel = "noopener noreferrer"

      // 添加到 DOM 中（隐藏）
      link.style.display = "none"
      document.body.appendChild(link)

      // 触发点击事件
      link.click()

      // 移除元素
      document.body.removeChild(link)
    },
    goTo(url) {
      this.$router.push(url)
    },
    handleClick() {
      // Toast(!!navigator.clipboard)
      // this.handleInvite()
    },
    handleInvite() {
      const url = process.env.VUE_APP_IMAGE_URL
      const inviteLink = url + "/home?inviteCode=" + this.todoInfo.inviteCode

      // 回退方法：使用 document.execCommand('copy')
      const fallbackCopy = (text, resolve, reject) => {
        const textArea = document.createElement("textarea")

        // 设置样式使文本域不可见但可选择
        textArea.style.position = "fixed"
        textArea.style.left = "-999999px"
        textArea.style.top = "-999999px"
        textArea.style.opacity = "0"
        textArea.style.zIndex = "-1000"

        // 关键：避免移动端弹出键盘
        textArea.setAttribute("readonly", "")
        textArea.value = text

        document.body.appendChild(textArea)
        textArea.select()
        textArea.setSelectionRange(0, 99999) // 移动端兼容

        try {
          const successful = document.execCommand("copy")
          document.body.removeChild(textArea)

          if (successful) {
            console.log("execCommand copy 成功")
            resolve(true)
          } else {
            console.error("execCommand copy 失败")
            reject(new Error("execCommand copy 返回 false"))
          }
        } catch (err) {
          document.body.removeChild(textArea)
          console.error("execCommand copy 抛出异常:", err)
          reject(err)
        }
      }

      // 通用复制方法，兼容各种浏览器
      const copyToClipboard = (text) => {
        return new Promise((resolve, reject) => {
          // 方法1: 使用现代 Clipboard API (需要 HTTPS 或 localhost)
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard
              .writeText(text)
              .then(() => {
                console.log("Clipboard API 成功")
                resolve(true)
              })
              .catch((err) => {
                console.log("Clipboard API 失败，尝试回退方法:", err)
                fallbackCopy(text, resolve, reject)
              })
          } else {
            console.log("不支持 Clipboard API，使用回退方法")
            fallbackCopy(text, resolve, reject)
          }
        })
      }

      // copyToClipboard(inviteLink)
      //   .then(() => {
      //     Toast.success(this.$t("todo.copySuccess"))
      //   })
      //   .catch((err) => {
      //     Toast.fail(this.$t("todo.copyFailed") || "复制失败")
      //     console.error("复制失败:", err)
      //   })
    },
  },
  created() {
    this.getTodoList()
    clipboard.on("success", (e) => {
      // console.info("Action:", e.action)
      // console.info('Text:', e.text);
      // console.info("Trigger:", e.trigger)
      Toast.success(this.$t("todo.copySuccess"))
      e.clearSelection()
    })

    clipboard.on("error", function (e) {
      console.error("Action:", e.action)
      console.error("Trigger:", e.trigger)
      Toast.fail(e)
    })
  },
}
</script>

<style scoped>
/deep/.van-button {
  padding: 0 10px;
}
</style>
